import React, { useContext, useEffect, useState } from 'react';
import useForm from 'react-hook-form';
import { TextInput } from 'dw-au-react-components';
import { CartContext } from '../../../Context/CartContext';
import { CloseIcon } from '../../../svg';

function VoucherCodeForm() {
	const { addCouponCode, removeCouponCode, couponCode } =
		useContext(CartContext);
	const [showCloseBtn, setShowCloseBtn] = useState(false);
	const [couponCodeValue, setCouponCodeValue] = useState('');

	const { register } = useForm({
		mode: 'onBlur',
		defaultValues: {
			couponCode: couponCode,
		},
	});

	useEffect(() => {
		if (couponCode) {
			setCouponCodeValue(couponCode);
			setShowCloseBtn(true);
		}
	}, []);

	const handleOnChange = (e) => {
		let voucherValue = e.target.value;

		if (voucherValue.length >= 0) {
			setCouponCodeValue(voucherValue);
			addCouponCode(voucherValue);
			setShowCloseBtn(true);
		} else {
			setShowCloseBtn(false);
			removeCouponCode();
		}
	};

	const handleOnClick = () => {
		setCouponCodeValue('');
		removeCouponCode();
		setShowCloseBtn(false);
	};

	return (
		<TextInput
			name='couponCode'
			maxLength={10}
			placeholder='Enter coupon code'
			register={register}
			icon={
				showCloseBtn ? (
					<CloseIcon onClick={handleOnClick} className='cursor-pointer' />
				) : null
			}
			onChange={handleOnChange}
			value={couponCodeValue}
		/>
	);
}

export default VoucherCodeForm;
